// removed by extract-text-webpack-plugin
module.exports = {"form":"SignInForm__form___1uS8O","signin-button":"SignInForm__signin-button___1tkke"};